'use client';
import * as React from 'react';
import { motion, useAnimation } from 'framer-motion';

export interface SquarePenIconHandle {
	startAnimation: () => void;
	stopAnimation: () => void;
}

interface SquarePenIconProps {
	isHovered?: boolean;
	size?: number;
	className?: string;
}

const penVariants = {
	normal: {
		rotate: 0,
		x: 0,
		y: 0,
	},
	animate: {
		rotate: [-0.5, 0.5, -0.5],
		x: [0, -1, 1.5, 0],
		y: [0, 1.5, -1, 0],
		transition: { repeat: Infinity, duration: 1.5 },
	},
};

export function SquarePenIcon({
	isHovered = false,
	size = 24,
	className = '',
}: SquarePenIconProps) {
	const controls = useAnimation();

	React.useEffect(() => {
		void controls.start(isHovered ? 'animate' : 'normal');
	}, [isHovered, controls]);

	return (
		<div
			className={`select-none p-2 flex items-center justify-center ${className}`}
		>
			<motion.svg
				xmlns='http://www.w3.org/2000/svg'
				width={size}
				height={size}
				viewBox='0 0 24 24'
				fill='none'
				stroke={isHovered ? '#FF69B4' : 'currentColor'}
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				style={{ overflow: 'visible' }}
			>
				<path d='M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7' />
				<motion.path
					d='M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z'
					variants={penVariants}
					animate={controls}
				/>
			</motion.svg>
		</div>
	);
}
